require('bijou/base')

#== Description
# This widget handles:
# - hiding form validation errors on the proof of policy form
# - selecting the contents of a textarea on the digital badge cert page
#
#== Behaviour
# - On form submit on hide any validation errors
# - On click on the textarea, select its entire contents

"use strict"

$.widget "chopin.pop", $.bijou.base,
  _create: ->
    errors = @element.find(".errors")

    @_on
      "submit form": ->
        errors.hide()

      "click .js-pop-code": (e) ->
        e.target.select()
